import router from "@/router/";

const mutationListeners = {};

const actionBeforeListeners = {
  "auth/logout"() {
    if (router.currentRoute.name !== "home") {
      router.push({ name: "home" });
    }
  }
};

const actionAfterListeners = {};

export default function configureModerator(store) {
  store.subscribe(({ type }) => {
    const listener = mutationListeners[type];
    if (listener) listener(store);
  });

  store.subscribeAction({
    before: ({ type }) => {
      const listener = actionBeforeListeners[type];
      if (listener) listener(store);
    },
    after: ({ type }) => {
      const listener = actionAfterListeners[type];
      if (listener) listener(store);
    }
  });
}
